import type {AxiosError} from 'axios';
import {useMutation, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {
	sendRecoveryCode,
	type SendRecoveryCodeErrorResponse,
	type SendRecoveryCodeRequest,
	type SendRecoveryCodeResponse,
} from '../../http';

export function useSendRecoveryCode(
	options?: UseMutationOptions<SendRecoveryCodeResponse, AxiosError<SendRecoveryCodeErrorResponse>, SendRecoveryCodeRequest>,
): UseMutationResult<SendRecoveryCodeResponse, AxiosError<SendRecoveryCodeErrorResponse>, SendRecoveryCodeRequest> {
	return useMutation<SendRecoveryCodeResponse, AxiosError<SendRecoveryCodeErrorResponse>, SendRecoveryCodeRequest>(
		(request) => sendRecoveryCode(request).then(({data}) => data),
		options,
	);
}
